import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "./commonSlice";
import commonService from "../common/commonService";
import { API_URLS, STATUS_CODES } from "../common/constants";
import { toast } from "react-toastify";

const initialState = {
  errorMessage: "",
  error: null,
  questionList: [],
  totalPages: null,
  hasNextPage: true,
  answerSubmittedDetails: null,
};

export const fetchQuestionList = createAsyncThunk(
  "question",
  async (data, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    const res = await commonService.getRequest(
      API_URLS.QUESTIONNAIRE_LIST + `?${commonService.getQueryFromObject(data)}`
    );
    dispatch(stopLoading());
    if (res.statusCode !== STATUS_CODES.SUCCESS) {
      toast.error(res.message);
      return rejectWithValue(res.message);
    }
    return res;
  }
);

export const submitQeustionnaireAnswer = createAsyncThunk(
  "submit/question",
  async (data, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    const res = await commonService.postRequest(
      API_URLS.SUBMIT_QUESTIONNAIRE_ANSWER,
      data
    );
    dispatch(stopLoading());
    if (res.statusCode !== STATUS_CODES.SUCCESS) {
      toast.error(res.message);
      return rejectWithValue(res.message);
    }
    return res;
  }
);

const questionnaireSlice = createSlice({
  name: "data",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestionList.pending, (state) => {
        return {
          ...state,
          error: null,
          questionList: [],
          hasNextPage: true,
        };
      })
      .addCase(fetchQuestionList.fulfilled, (state, action) => {
        return {
          ...state,
          error: false,
          questionList: action.payload.data,
          totalPages: action.payload.totalPages,
          hasNextPage: action.payload.hasNextPage,
        };
      })
      .addCase(fetchQuestionList.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
          hasNextPage: true,
        };
      })
      .addCase(submitQeustionnaireAnswer.pending, (state) => {
        return {
          ...state,
          error: null,
          isQuestionnairAnswerSubmitted: false,
        };
      })
      .addCase(submitQeustionnaireAnswer.fulfilled, (state, action) => {
        return {
          ...state,
          error: false,
          answerSubmittedDetails: action.payload.data,
          isQuestionnairAnswerSubmitted: true,
        };
      })
      .addCase(submitQeustionnaireAnswer.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
          isQuestionnairAnswerSubmitted: false,
        };
      })
  },
});

const { reducer } = questionnaireSlice;
export default reducer;
